var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0F1118",
    opacity: 0.8,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.3528404,14.1058737 L21.8941263,24.6471596 C22.6751748,25.4282082 22.6751748,26.6945381 21.8941263,27.4755867 C21.5528356,27.8168773 21.0996371,28.0232346 20.6181333,28.0565912 L9.29223536,28.8412033 C8.19030686,28.9175404 7.23513385,28.0861343 7.15879673,26.9842058 C7.1524208,26.892169 7.1524208,26.7998014 7.15879673,26.7077646 L7.9434088,15.3818667 C8.01974592,14.2799382 8.97491893,13.4485321 10.0768474,13.5248692 C10.5583513,13.5582259 11.0115498,13.7645831 11.3528404,14.1058737 Z",
    transform: "rotate(-135 16 20)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.076c3fb2c9035d5966d892bf49459369.svg";
export { ForwardRef as ReactComponent };